<style lang="scss">
.monitorMachineMoldTable .el-progress-bar__outer {
  background: #606672;
}

.monitorMachineMoldTable .el-progress__text {
  color: #ffffff;
}

.monitorMachineMoldTable::before {
  z-index: inherit;
}

.monitorMachineMoldTable.el-table {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table--border:after,
.monitorMachineMoldTable.el-table--group:after,
.monitorMachineMoldTable.el-table:before {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table tr {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #33333a !important;
}

.monitorMachineMoldTable .el-table td.gutter,
.monitorMachineMoldTable.el-table th.gutter {
  background: transparent;
}

.monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px;
}

.monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

.page-indicator {
  color: #c0c4cc;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>

<style lang="scss" scoped="scoped">
.cell-class-name {
  border-bottom: 1px solid red !important;
}
.transparent-btn2 {
  background: transparent !important;
  border-color: #c0c4cc !important;
  //   color: #fff;

  &:hover {
    background: rgba(64, 158, 255, 0.1) !important;
    border-color: #c0c4cc !important;
    color: #fff;
  }

  &.is-disabled {
    background: transparent !important;
    border-color: #c0c4cc !important;
    color: #fff;
  }
}
.transparent-btn {
  background: transparent !important;
  border-color: #409eff !important;

  &:hover {
    background: rgba(64, 158, 255, 0.1) !important;
    border-color: #409eff !important;
  }

  &.is-disabled {
    background: transparent !important;
    border-color: #c0c4cc !important;
  }
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#1D1D24' : '#000466' }">
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
      <!-- 翻页模式指示器 -->
      <div v-if="displayMode === 'page'" class="page-indicator">
        <span>{{ $t('dangqianye') }}: {{ currentPage }}/{{ totalPages }}</span>
        <span style="margin: 0 8px;color: #C0C4CC">|</span>
        <span>{{ $t('zongtiaoshu') }}: {{ total }}</span>
        <el-button size="mini" @click="goPrevPage" :disabled="currentPage <= 1" plain class="transparent-btn2">{{ $t('shangyiye') }}</el-button>
        <el-button size="mini" @click="goNextPage" :disabled="currentPage >= totalPages" plain type="primary" class="transparent-btn">{{ $t('xiayiye') }}</el-button>
      </div>
      <div v-else class="page-indicator">
        <span>{{ $t('gundongmoshi') }}</span>
        <span style="margin: 0 8px;color: #C0C4CC">|</span>
        <span>{{ $t('zongtiaoshu') }}: {{ displayData.length }}</span>
      </div>
    </div>
    <div :style="{ height: contentHeight + 'px' }">
      <el-table ref="table" class="monitorMachineMoldTable" :data="displayData" style="width: 100%" :max-height="contentHeight" :row-style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#1d1d24' : '#000355', height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: 'transparent', color: '#FFFFFF', 'font-size': '14px' }" :header-cell-style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#33333A' : '#151599', color: '#C0C4CC', padding: '0px', height: '42px', borderColor: 'transparent', 'font-size': '14px' }" cell-class-name="cell-class-name">
        <el-table-column :label="$t('yewuleixing')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ scope.row.type }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('yewumingcheng')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ scope.row.warning_user }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('yujingshijian')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ scope.row.create_time != null ? dayjs.unix(scope.row.create_time / 1000).format('YYYY-MM-DD HH:mm:ss') : '' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('yujingneirong')" width="900">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ scope.row.msg }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_customize_senmusi_monitor_warning_message_info',
  components: {},
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    }
  },
  data() {
    return {
      textColor: { '1': 'rgba(255, 58, 94, 1)', '2': 'rgba(255, 200, 58, 1)', '3': 'rgba(57, 241, 109, 1)', '4': 'rgba(57, 241, 109, 1)', '5': 'rgba(57, 241, 109, 1)' },
      bgColor: { '1': 'rgba(255, 58, 94, 0.2)', '2': 'rgba(255, 200, 58, 0.2)', '3': 'rgba(57, 241, 109, 0.2)', '4': 'rgba(57, 241, 109, 0.2)', '5': 'rgba(57, 241, 109, 0.2)' },

      // 配置相关
      displayMode: 'page',
      pageSize: 10,
      autoPageTime: 10,
      refreshInterval: 120,

      // 翻页模式相关
      currentPage: 1,
      totalPages: 0,
      total: 0, // 总数据条数
      allData: [], // 所有数据（滚动模式使用）
      displayData: [], // 当前显示的数据

      // 定时器
      interval: null,
      timer: null,
      pageTimer: null,

      contentHeight: 0,
      rowHeight: 0,
      maintainMap: {
        0: 'weibaoyang',
        1: 'baoyangzhong',
        2: 'yiwancheng'
      },
      repairMap: {
        0: 'daichuli',
        1: 'chulizhong',
        2: 'yiwancheng'
      },
      isStopListScroll: false
    };
  },
  created() {
    this.loadConfig();
    this.listData();
    this.startTimers();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.utils.event_hub.$on('SetModelManageLayout', () => {
      this.loadConfig();
      this.restartTimers();
    });
  },
  destroyed() {
    this.clearTimers();
  },
  methods: {
    // 加载配置
    loadConfig() {
      const monitorSetting = JSON.parse(localStorage.getItem('MONITOR_SETTING')) || {};
      this.displayMode = monitorSetting.displayMode || 'page';
      this.pageSize = monitorSetting.pageSize || 10;
      this.autoPageTime = monitorSetting.autoPageTime || 10;
      this.refreshInterval = monitorSetting.refreshInterval || 120;
    },

    // 启动定时器
    startTimers() {
      this.clearTimers();

      // 数据刷新定时器
      this.timer = setInterval(() => {
        this.listData();
      }, this.refreshInterval * 1000);

      // 翻页或滚动定时器
      if (this.displayMode === 'page') {
        this.startAutoPage();
      } else {
        this.setAutoScroll();
      }
    },

    // 重启定时器
    restartTimers() {
      this.clearTimers();
      this.listData();
      this.startTimers();
    },

    // 清除所有定时器
    clearTimers() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (this.pageTimer) {
        clearInterval(this.pageTimer);
        this.pageTimer = null;
      }
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },

    // 启动自动翻页
    startAutoPage() {
      if (this.pageTimer) {
        clearInterval(this.pageTimer);
      }
      this.pageTimer = setInterval(() => {
        this.goNextPage();
      }, this.autoPageTime * 1000);
    },

    // 获取数据
    async listData() {
      try {
        const params = {
          orderBy: 'createTime desc'
        };

        if (this.displayMode === 'page') {
          // 翻页模式：传递分页参数offset
          params.offset = this.currentPage;
          params.pageSize = this.pageSize;
        } else {
          // 滚动模式：获取所有数据，可能需要调整pageSize为较大值
          params.pageSize = 100000; // 或者更大的值，确保获取所有数据
        }

        const response = await this.http.get('/web/warning/log/queryList', {
          params: params
        });

        if (this.displayMode === 'page') {
          // 翻页模式：使用接口返回的当前页数据
          this.displayData = response.data.rows || [];
          this.total = response.data.total || 0;
          this.totalPages = Math.ceil(this.total / this.pageSize);

          // 如果当前页没有数据且不是第一页，则回到第一页
          if (this.displayData.length === 0 && this.currentPage > 1) {
            this.currentPage = 1;
            this.listData();
          }
        } else {
          // 滚动模式：保存所有数据用于前端滚动显示
          this.allData = response.data.rows || [];
          this.displayData = this.allData;
          this.$nextTick(() => {
            this.setAutoScroll();
          });
        }
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },

    // 上一页
    goPrevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.listData(); // 重新获取数据
      } else {
        // 已经是第一页，可以循环到最后一页
        this.currentPage = this.totalPages;
        this.listData();
      }
    },

    // 下一页
    goNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.listData(); // 重新获取数据
      } else {
        // 已经是最后一页，可以循环到第一页
        this.currentPage = 1;
        this.listData();
      }
    },

    // 设置自动滚动
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }

      const listDiv = this.$refs.table.bodyWrapper;
      if (!listDiv) return;

      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },

    resize() {
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
        this.rowHeight = (this.contentHeight - 42 - 5) / 10;
      }, 800);
    }
  }
};
</script>
